export enum CLAIMS_DOMAIN {
  DOCUMENTS = 'documents',
}

export const CLAIMS_DOMAIN_KEY = 'controlClaims';
